import Vue from 'vue';
import Moment from 'moment';

import { EduacProvider } from '@/core/providers/eduac.provider';
import { SectionSubmissionDates } from '@/courses/models/section.model';
import { Holiday } from '@/tools/models/holiday.model';
import { SCHOOL_DAY_STATUS } from '@/tools/values/school-calendar.values';

class SectionSchooolCalendarProviderClass extends EduacProvider {

  schoolDays = Vue.observable({ dates: [] });
  holidays: Holiday[] = Vue.observable([]);
  preferences: any = Vue.observable({});

  get hasSchoolDays(): boolean {
    return this.schoolDays.dates.length > 0;
  }
  
  get schoolDaysList() {
    return this.schoolDays.dates || [];
  }

  getCurrentSchoolDays(minDate: string = null): string[] {
    const schoolDays: any[] = this.schoolDaysList;
    const now = Moment(Moment().format('YYYY-MM-DD'));
    const dates = schoolDays.filter(sd => {
      let isValid = now.isSame(Moment(sd)) || now.isBefore(Moment(sd));
      if(minDate) {
        const min = Moment(minDate);
        const isMinDateValid = min.isSame(Moment(sd)) || min.isBefore(Moment(sd));
        isValid = isValid && isMinDateValid;
      }
      return isValid;
    });
    return dates;
  }

  getDefaultDueDate(defaultDueDateForTasks = null, minDate: string = null) {
    let defaultLastDate = '';
    const currentSchoolDays = this.getCurrentSchoolDays(minDate);
    if(defaultDueDateForTasks && this.hasSchoolDays) {
      const schooldays = currentSchoolDays;
      let day = defaultDueDateForTasks;
      if(currentSchoolDays.length > 0) {
        defaultLastDate = schooldays[schooldays.length - 1];
        if(currentSchoolDays.length > day) {
          defaultLastDate = schooldays[day];
        }
      }
    }
    return defaultLastDate;
  }

  getDefaultLastDate(dueDate = '', defaultDueDate = null, defaultLastDateForTasks = 0, defaultDueDateForTasks = null, form, minDate: string = null) {
    let defaultLastDate = '';
    if(defaultDueDateForTasks && this.hasSchoolDays) {
      const schoolDays = this.getCurrentSchoolDays(minDate);
      let lastDateIndex = defaultLastDateForTasks + defaultDueDateForTasks;
      let defaultDueDay = schoolDays.length - 1;
      if(dueDate) {
        defaultDueDay = schoolDays.findIndex(day => day === form.dueDate.value);
        lastDateIndex = defaultDueDay + defaultLastDateForTasks;
      }
      if(schoolDays.length > 0) {
        defaultLastDate = schoolDays[defaultDueDay];
        if(schoolDays.length > lastDateIndex) {
          defaultLastDate = schoolDays[lastDateIndex];
        }
      }
    }
    return defaultLastDate;
  }

  getSchoolDayIndex(date: string = ''): number {
    let day = null;
    if(date) {
      day = this.schoolDaysList.findIndex(d => d == date);
      day++;
    }
    return day
  }

  getSchoolDayDate(dateIndex: number = null) {
    let date = '';
    if(dateIndex) {
      return date = this.schoolDaysList[dateIndex - 1];
    }
    return date;
  }

  getHolidays(calendarHolidays: Holiday[]): string[] {
    let dates: string[] = [];
    calendarHolidays.forEach(h => {
      dates.push(h.startDate);
      if(h.endDate) {
        dates.push(h.endDate);
      }
    });
    return dates;
  }

  getEventsColor(date: string, holidays: Holiday[]) {
    let colors = this.preferences.colors;
    let holiday = holidays.find(h => h.startDate == date || h.endDate == date);
    if(holiday) {
      if(holiday.official) {
        return colors.US_HOLIDAYS;
      }
      if(holiday.status == SCHOOL_DAY_STATUS.NOTIFIED) {
        return colors.EVENTS;
      }
      if(!holiday.official && holiday.status == SCHOOL_DAY_STATUS.OBSERVED) {
        return colors.DAY_OFF;
      }
    }
  }

  onHomeworkChanged(value, form, defaultDueDate, defaultLastDate) {
    if(this.hasSchoolDays) {
       if(value) {
         form.set('dueDate', defaultDueDate);
         form.set('lastDate', defaultLastDate);
       } else {
         form.set('dueDate', '');
         form.set('lastDate', '');
       }
     }
   }

  getDateDisclamer(
    defaultDate: string,
    canValidate: boolean,
    field: string,
    autoProp: string,
    edition: boolean,
    submissionDates: SectionSubmissionDates,
    form: any) {
      let res = '';
      const dates = submissionDates;
      if(canValidate) {
        if(edition) {
          if(dates) {
            if(dates[autoProp] && dates[field] === form[field].value) {
              res = '';
            } else {
              res = this.getDueDateMessage(form[field].value, defaultDate);
            }
            return res;
          }
        }
        return this.getDueDateMessage(form[field].value, defaultDate);
      }
  }

  getDueDateMessage(dueDate: string, dateToCompare: string): string {
    if(dueDate) {
      if(dateToCompare !== dueDate) {
        return this.$vue.$i18n.t('courses.objects.dateChangedManually').toString();
      }
    }
    return '';
  }
  
}

export const SectionSchooolCalendarProvider =  new SectionSchooolCalendarProviderClass();